// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event-spinning-text[data-v-7469490f]{margin-top:40px}.event-spinning-text>*+*[data-v-7469490f]{margin-top:20px}.event-spinning-text__heading[data-v-7469490f]{text-transform:uppercase;font-size:14px}@media(min-width:768px){.event-spinning-text__heading[data-v-7469490f]{font-size:20px}}.event-spinning-text__content[data-v-7469490f]{color:#657182;line-height:20px}", ""]);
// Exports
module.exports = exports;
